<template>
  <QuotationResourceForm
    @submit="submit"
    v-model="formResource"
    @cancel="cancelQuotationButton"
    :form="readonlyForm"
    @return="previousStep"
    :emissionType="firstForm.emissionType"
    :submodalityType="firstForm.subModality"
    without-recursal
  />
</template>
<script>
import QuotationResourceForm from "../components/QuotationResourceForm";
import { QuotationMixin } from "@/mixins/NewQuotationMixin";
export default {
  name: "QuotationFirstStepResource",
  data: () => ({
    formResource: {}
  }),
  mixins: [QuotationMixin],
  components: {
    QuotationResourceForm
  },
  created() {
    this.formResource = { ...this.form };
  },
  computed: {
    nextQuotationStep() {
      return {
        name: "quotation step deadline",
        step: 4
      };
    },
    previousQuotationStep() {
      return {
        name: "quotation step insured",
        step: 2
      };
    }
  },
  methods: {
    submit(form) {
      this.$emit(
        "updateStep",
        this.payloadQuotation(form, this.nextQuotationStep)
      );
    },
    previousStep() {
      this.$emit(
        "updateStep",
        this.payloadQuotation(this.formResource, this.previousQuotationStep)
      );
    }
  },
  props: {
    form: Object,
    readonlyForm: Object,
    firstForm: Object,
    previous: String
  }
};
</script>
